// validators/constant.ts
import { assertValidation } from "../errors.mjs";
import { registry } from "../registry.mjs";
import { AbstractValidator } from "../types.mjs";
var ConstantValidator = class extends AbstractValidator {
  constant;
  constructor(constant2) {
    super();
    this.constant = constant2;
  }
  validate(value) {
    const extra = this.constant === null ? "" : ` (${typeof this.constant})`;
    assertValidation(value === this.constant, `Value does not match constant "${this.constant}"${extra}`);
    return value;
  }
};
function constant(constant2) {
  return new ConstantValidator(constant2);
}
registry.set("constant", ConstantValidator);
export {
  ConstantValidator,
  constant
};
//# sourceMappingURL=constant.mjs.map
